{
  "columnResizer": "أداة تغيير حجم العمود",
  "loading": "جارٍ التحميل...",
  "loadingMore": "جارٍ تحميل المزيد...",
  "resizeColumn": "تغيير حجم العمود",
  "sortAscending": "فرز بترتيب تصاعدي",
  "sortDescending": "فرز بترتيب تنازلي"
}
